import { useNotificationStore } from "@/stores/apps/notification"
import { useChangelogStore } from "@/stores/apps/changelog"
import { useAuthStore } from "@/stores/auth"
import { type RouteMetaAuth } from "@/types/auth.d"
import { type RouteLocationNormalized } from "vue-router"
import { NotificationWs } from "@/utils/ws/notification_ws"
import { useStoreI18n } from "@/composables/useStoreI18n"
import i18n from "@/utils/i18n";
import { useLocalesStore } from "@/stores/i18n"
import { getValidRedirectPath, LOGIN_REDIRECT_QUERY } from "@/utils/loginRedirect"
import { isAdminRole, isSuperadminRole } from "@/utils/roles"

const { t, locale } = i18n.global

export async function authCheck(route: RouteLocationNormalized) {
	const meta: RouteMetaAuth = route.meta
	const { checkAuth, authRedirect, auth, roles } = meta
	

	const authStore = useAuthStore()

	if (route?.redirectedFrom?.name === "Logout") {
		authStore.setLogout()
	}

	if (auth === true) {
		if (!authStore.isLogged) {
			return {
				path: "/login",
				query: { [LOGIN_REDIRECT_QUERY]: route.fullPath },
			}
		}
		const storeNotification = useNotificationStore()
		const storeChangelog = useChangelogStore()
		
		// MANAGER FIRST TIME AUTH ( REFRESH PAGE , FIRST OPEN )
		if( Object.keys(authStore.full_user).length == 0)
		{
			// FIRST TIME USER ENTER THE PAGE
			await Promise.all([
				authStore.getUser(),
				storeNotification.fetchNotifications(),
				storeChangelog.fetchUnread().catch(() => {}),
			]);
			NotificationWs()
			const localeStore = useLocalesStore();
			localStorage.setItem("language", authStore.full_user.language)
			localeStore.setLocale(authStore.full_user.language)
			if (authStore.first_time_login) {
				authStore.first_time_login = false
			}
		}

		if (!authStore.isLogged) {
			return {
				path: "/login",
				query: { [LOGIN_REDIRECT_QUERY]: route.fullPath },
			}
		}
		console.log(roles);

		// Game masters can only access booking_detail_gm, not booking_detail
		const isGameMaster = authStore.user?.rol === 3 || authStore.full_user?.rol === 3
		if (isGameMaster && (route.name === "BookingDetail" || route.name === "BookingDetailNew")) {
			const bookingId = route.params.id
			if (bookingId) {
				return { name: "BookingDetailGM", params: { id: bookingId } }
			}
			return { name: "Calendar" }
		}

		if (meta.superadmin && !isSuperadminRole(authStore.user?.rol ?? authStore.full_user?.rol)) {
			return { path: "/events_list" }
		}
		
		// if (roles && !authStore.isRoleGranted(roles)) {
		// 	window.location.href = "/login" + window.location.search
		// 	return false
		// }
	}
	

	if (checkAuth === true) {
		if (authStore.isLogged) {
			const redirectPath = getValidRedirectPath(route.query[LOGIN_REDIRECT_QUERY])
			const defaultPath = isAdminRole(authStore.full_user?.rol) ? "/events_list" : "/calendar"

			if (roles) {
				if (authStore.isRoleGranted(roles)) {
					return redirectPath || authRedirect || defaultPath
				}
				return route.path
			}
			return redirectPath || authRedirect || defaultPath
		}
	}
}
